import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { DateTimeInputComponent } from 'components/input/date-time-input/date-time-input.component';
import { FileUploadComponent, UploadedFile } from 'components/input/file-upload/file-upload';
import { InputType } from 'enums/InputType';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TaskAttachmentModel } from 'models/generated/Entities.GormCrm.TaskAttachment';
import { SelectListItemModel } from 'models/SelectList';
import { Inputs } from 'modules/inputs';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { TaskService } from 'services/task.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'new-task-action',
	templateUrl: './new-task-action.component.html',
	providers: [FormValidationService],
	imports: [Layout, Inputs, DateTimeInputComponent, FileUploadComponent, TranslatePipe]
})
export class NewTaskActionComponent {

	inputType = InputType;

	@Output() taskActionSaved = new EventEmitter<boolean>();
	@Output() taskActionBusy = new EventEmitter<boolean>();
	@ViewChild(ButtonComponent) saveButton?: ButtonComponent;

	private _taskAction: TaskActionModel = new TaskActionModel();
	@Input()
	set taskAction(ta: TaskActionModel) {
		this._taskAction = ta;
		this.showFiles();
	}
	get taskAction() { return this._taskAction }

		
	@Input() enableSaveButton = false;

	plannedDate?: { date: Date, dateOnly: boolean; };
	usersList: SelectListItemModel[];
	taskAreaList: SelectListItemModel[] = [];
	taskActionTypeList: SelectListItemModel[] = [];
	uploading = false;
	uploadedFiles: UploadedFile[] = [];

	constructor(userService: UserService, translate: TranslatePipe, private readonly taskService: TaskService) {

		this.usersList = userService.getUserSelectList();

		taskService.getAllTaskAreas().then(taskAreas => {
			for (let area of taskAreas) {
				this.taskAreaList.push(new SelectListItemModel(area.id!, translate.transform('task-area.area-name.' + area.name)));
			}
		});

		this.taskActionTypeList = taskService.getTaskActionTypes();
	}

	attachmentsChanged() {
		this.taskAction.taskAttachments = this.uploadedFiles.map(file => {
			const taskAttachment = new TaskAttachmentModel();
			taskAttachment.fileReferenceId = file.fileReference?.id;
			return taskAttachment;
		});
	}

	isUploading(uploading: boolean) {
		this.uploading = uploading;
		this.taskActionBusy.emit(uploading);
	}

	async saveTaskAction() {
		this.taskAction.include(ta => ta.taskAttachments);
		try {
			await this.taskService.addTaskActionToTaskflow(this.taskAction);
			this.taskActionSaved.emit(true);
		}
		catch {
			this.saveButton?.reset();
		}
	}

	setPlannedDate(value?: { date?: Date, dateOnly: boolean }) {
		this.taskAction.dateOnly = true;
		this.taskAction.plannedDate = undefined;
		if (value) {
			this.taskAction.dateOnly = value.dateOnly;
			this.taskAction.plannedDate = value.date;
		}
	}

	showFiles() {
		this.uploadedFiles = [];
		this.taskAction.taskAttachments.forEach(attachment => {
			var uploadedFile = new UploadedFile(attachment.fileReference!.fileName);
			uploadedFile.fileReference = attachment.fileReference
			this.uploadedFiles.push(uploadedFile);
		});
	}
}
